export const paths = {
  home: {
    path: '/',
    getHref: () => '/',
  },

  auth: {
    login: {
      path: '/login',
      getHref: () => '/login',
    },
    logout: {
      path: '/logout',
      getHref: () => '/logout',
    },
  },

  input: {
    text: {
      path: '/Users/registries',
      getHref: () => '/Users/registries',
    },
    graphic: {
      path: '',
      getHref: () => 'https://gb-regi.glytoucan.org/',
    },
  },

  search: {
    graphic: {
      path: '',
      getHref: () => 'https://gb.glytoucan.org/',
    },
    text: {
      path: '/text-search',
      getHref: () => '/text-search',
      // path: '',
      // getHref: () => 'https://glycosmos.org/glycans/text/ExactMatch',
    },
    organism: {
      path: '/organism-search',
      getHref: () => 'https://glycosmos.org/glycans/organisms',
    },
    mass: {
      path: '/mass-search',
      getHref: () => 'https://glycosmos.org/glycans/mass/range',
    },
    composition: {
      path: '/composition-search',
      getHref: () => 'https://glycosmos.org/glycans/composition',
    },
    glygen: {
      path: '/glygen-search',
      getHref: () => 'https://glygen.org/glycan-search',
    },
  },

  glycan: {
    root: {
      path: '/Structures',
      getHref: () => '/Structures',
    },
    list: {
      path: '',
      getHref: () => '/Structures',
    },
    detail: {
      path: 'Glycans/:accessionNumber',
      getHref: (accessionNumber: string) =>
        `/Structures/Glycans/${accessionNumber}`,
    },
    preview: {
      path: 'preview/:format/:submissionNumber',
      getHref: (format: string, submissionNumber: string) =>
        `/Structures/preview/${format}/${submissionNumber}`,
    },
  },

  tools: {
    root: {
      path: '/tools',
      getHref: () => '/tools',
    },
    list: {
      path: '',
      getHref: () => '/tools',
    },
    byonicConverter: {
      path: 'byonic-summary-worksheet-converter',
      getHref: () => '/tools/byonic-summary-worksheet-converter',
    },
  },

  user: {
    root: {
      path: '/Users',
      getHref: () => '/Users',
    },
    profile: {
      path: 'profile',
      getHref: () => '/Users/profile',
    },
    submission: {
      path: 'structure',
      getHref: () => '/Users/structure',
    },
    submissionDetail: {
      path: 'structure/preview/:format/:submissionNumber',
      getHref: (format: string, submissionNumber: string) =>
        `/Users/structure/preview/${format}/${submissionNumber}`,
    },
    document: {
      path: '',
      getHref: () => 'https://doc.glytoucan.org/',
    },
  },

  feedback: {
    path: '/feedback',
    getHref: () => '/feedback',
  },
  // NOTE: The following (`legacy`) is legacy routing setting to maintain system compatibility.
  //       You probably don't need to edit these routings.
  legacy: {
    glycopeptide: {
      accession: {
        path: '/glycopeptide-accession',
      },
      entry: {
        path: '/glycopeptide-entry',
      },
      submission: {
        path: '/glycopeptide-submission',
      },
    },
    glycoprotein: {
      accession: {
        path: '/glycoprotein-accession',
      },
      entry: {
        path: '/glycoprotein-entry',
      },
      submission: {
        path: '/glycoprotein-submission',
      },
    },
    byonicConverter: {
      path: '/byonic-summary-worksheet-converter',
      getHref: () => '/byonic-summary-worksheet-converter',
    },
    userProfile: {
      path: '/user_profile',
      getHref: () => '/user_profile',
    },
  },
} as const;
